import Navbar  from "../NavBar/NavBar.js";
import Footer from "../Home/Footer.js"
import AD from "./groupe_pages/AD/AD.js"
import AD2 from "./groupe_pages/AD/AD2.js"
import Whatsapp from "../Home/Whatsapp.js";
import Spinner from "../Home/Spinner.js";
import { useEffect } from "react";




const SolutionArtDeco = () => {
  useEffect(() => {
    // ✅ TITLE (قوي + keywords + branding)
    document.title =
      "Art Déco Maroc | Habillage Mural & Design 3D – UNIK SYSTEM";

    // ✅ DESCRIPTION (SEO + CTA + valeur)
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Solutions Art Déco au Maroc avec UNIK SYSTEM : habillage mural design, textures 3D, panneaux décoratifs et créations artistiques sur mesure. Idéal pour villas, bureaux et hôtels. Devis gratuit."
    );

    // ✅ KEYWORDS
    let keywords = document.querySelector("meta[name='keywords']");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.setAttribute("name", "keywords");
      document.head.appendChild(keywords);
    }
    keywords.setAttribute(
      "content",
      "art deco maroc, habillage mural maroc, panneau decoratif maroc, mur decoratif design, decoration murale moderne maroc, design interieur maroc, texture murale 3D maroc"
    );

    // ✅ ROBOTS
    let robots = document.querySelector("meta[name='robots']");
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "index, follow");

    // ✅ CANONICAL
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute(
      "href",
      "https://unik-system.com/art-deco-maroc"
    );

    // ✅ OPEN GRAPH (Facebook / WhatsApp)
    const setMetaProperty = (property, content) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMetaProperty(
      "og:title",
      "Art Déco Maroc – UNIK SYSTEM"
    );
    setMetaProperty(
      "og:description",
      "Habillage mural design, textures 3D et solutions décoratives haut de gamme au Maroc."
    );
    setMetaProperty(
      "og:image",
      "https://unik-system.com/static/media/1.67dbe73ae14da710f4e8.webp"
    );
    setMetaProperty(
      "og:url",
      "https://unik-system.com/art-deco-maroc"
    );
    setMetaProperty("og:type", "website");

    // ✅ TWITTER
    let twitterCard = document.querySelector("meta[name='twitter:card']");
    if (!twitterCard) {
      twitterCard = document.createElement("meta");
      twitterCard.setAttribute("name", "twitter:card");
      document.head.appendChild(twitterCard);
    }
    twitterCard.setAttribute("content", "summary_large_image");

    let twitterImage = document.querySelector("meta[name='twitter:image']");
    if (!twitterImage) {
      twitterImage = document.createElement("meta");
      twitterImage.setAttribute("name", "twitter:image");
      document.head.appendChild(twitterImage);
    }
    twitterImage.setAttribute(
      "content",
      "https://unik-system.com/static/media/1.67dbe73ae14da710f4e8.webp"
    );

  }, []);





  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <AD/>
            <AD2/>
            <Footer/>
        </div>    
    )
};

export default SolutionArtDeco;